import {matrixStyle, wellStyle, wellFlashClass, rowColumnToWellLabel} from './templateHelpers.js';

export default function spectralTemplate(data, containerIndex, matrixIndex, matrixData) {
    return `\
<div class="matrix xy-spectral" ${matrixStyle(matrixData)}>
    ${matrixData.wells.map((well, wellIndex) => `
    <div class="well-label ${wellFlashClass(data, wellIndex)}" ${wellStyle(data, containerIndex, well)}><span>${rowColumnToWellLabel(well.row, well.column)}</span></div>
    ${well.dataPoints.map(dataPoint => `
    <div class="data-point ${wellFlashClass(data, wellIndex)}" ${wellStyle(data, containerIndex, well)}><span>${dataPoint.wavelength};${dataPoint.value}</span></div>`).join('')}
    `).join('')}
</div>
`
}
